import cleanDeep from 'clean-deep'

export const hasFilters = (filters: object) => Boolean(Object.keys(cleanDeep(filters)).length)
